/**
 * @file 侧边导航任务列表
 * @author sunyingying01
 */

import React, {useCallback, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {flowResult} from 'mobx';
import {Tooltip, Popover} from 'antd';
import cx from 'classnames';

import JobsFilterSvg from '@assets/icons/filter.svg';
import {useRequestErrorHandler} from '@/utils/errorHandler';
import {defaultSelectJobUtil} from '@/modules/selectJobUtil';
import {jobIdSyncService} from '@/utils/JobIdSyncService';
import {STATUS_OPTIONS} from '@/dicts';
import {IProps} from '../index';
import JobFilter from '../Filter';
import styles from './index.module.less';

const JobsHeader: React.FC<IProps> = props => {
    const {projectsListStore} = props.store;

    const [filterOpen, setFilterOpen] = useState<boolean>(false);

    const {handleError} = useRequestErrorHandler();

    /** 点击筛选 获取最新任务列表 */
    const handleFilter = useCallback(
        async (val: FiltetStatusOptionsType) => {
            try {
                const {taskRunningStore} = props.store;
                projectsListStore.jobsListStore.setFilterStatus(val);
                const list = await flowResult(projectsListStore.jobsListStore.fetchList({job_status: val.status}));
                if (list.length > 0) {
                    jobIdSyncService.setJobId(list[0].job_id);
                    // 重新初始化 taskRunningStore
                    taskRunningStore.initTaskRunningStore(list[0].job_id);
                    await defaultSelectJobUtil(props.store, list[0], list[0].setDetailsLoading);
                }
            } catch (error) {
                handleError(error, '任务信息获取失败！');
            }
        },
        [projectsListStore.jobsListStore, props.store]
    );

    // 菜单展开状态
    const handleOpenChange = useCallback(
        (val: boolean) => setFilterOpen(val),
        []
    );

    return (
        <div className={styles.jobsHeader}>
            <div className={styles.title}>任务</div>
            <Popover
                content={
                    <JobFilter
                        statusOptions={STATUS_OPTIONS}
                        onFilter={handleFilter}
                        store={projectsListStore.jobsListStore}
                    />}
                trigger="click"
                placement="bottomLeft"
                classNames={{root: styles.popoverWrapper}}
                arrow={false}
                onOpenChange={handleOpenChange}
            >
                <Tooltip
                    color="#000"
                    trigger="hover"
                    classNames={{root: styles.tooltipWrapper}}
                    title="过滤"
                >
                    <div className={cx(styles.filterIcon,
                        {
                            [styles.filterIconActive]: filterOpen
                                || projectsListStore.jobsListStore.filterStatus?.status !== 'ALL'
                        })
                    }
                    >
                        <JobsFilterSvg />
                    </div>
                </Tooltip>
            </Popover>
        </div>
    );
};

export default observer(JobsHeader);
